<header class="border-bottom bg-white">
  <div class="container-fluid py-2 px-3 d-flex align-items-center justify-content-between">

    <!-- Brand -->
    <a class="d-flex align-items-center text-decoration-none" [routerLink]="['/']">
      <div
        class="rounded-3 bg-body-tertiary d-flex align-items-center justify-content-center"
        style="width:40px;height:40px;"
        aria-hidden="true"
      >
        <span class="fw-bold"><img src="/favicon1.ico" alt="Logo" width="40" height="40"></span>
      </div>
      <span class="ms-2 fw-semibold text-dark">Product Manager</span>
    </a>

    <!-- Right side -->
    <div class="d-flex align-items-center gap-2">

      @if (isLoggedIn$ | async) {

        <!-- EMAIL -->
        @if (userEmail$ | async; as email) {
          <div class="text-muted small d-none d-md-block">
            {{ email }}
          </div>
        }

        <!-- USER DROPDOWN -->
        <div ngbDropdown placement="bottom-end" container="body">
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm d-inline-flex align-items-center justify-content-center"
            ngbDropdownToggle
            aria-label="User menu"
            style="width:34px;height:34px;"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
              <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"/>
              <path fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8"/>
            </svg>
          </button>

          <div ngbDropdownMenu class="shadow-sm p-0">
            <div class="px-3 py-2 border-bottom">
              <div class="small text-muted">Signed in as</div>
              <div class="fw-semibold text-truncate" style="max-width: 220px;">
                {{ userEmail$ | async }}
              </div>
            </div>
            <!--
              <button ngbDropdownItem>Manage account</button>
              <button ngbDropdownItem>Settings</button>
            -->
            <div class="dropdown-divider m-0"></div>

            <button ngbDropdownItem class="text-danger" (click)="logout()">
              Logout
            </button>
          </div>
        </div>

      } @else {

        <!-- LOGIN BUTTON -->
        <!--
        <a
          class="btn btn-primary btn-sm"
          [routerLink]="['/login']"
        >
          Login
        </a>
        -->

      }

    </div>
  </div>
</header>
